export const mobile_sizes = () => {
  const width = Math.min(window.innerWidth, window.screen?.width || window.innerWidth);

  // MAX sizes in px
  const MOBILE_SMALL = 310;
  const MOBILE = 450;
  const MOBILE_LARGE = 768;
  const TABLET = 945;

  let device;
  switch (true) {
    case width < MOBILE_SMALL: device = 'mobileSmall'; break;
    case width < MOBILE: device = 'mobile'; break;
    case width < MOBILE_LARGE: device = 'mobileLarge'; break;
    case width < TABLET: device = 'tablet'; break;
    default: device = 'desktop';
  }

  return ({
    screenWidth: width,

    tabletAndLargerMediaQuery: `(min-width: ${TABLET}px)`,
    tabletMediaQuery: `(max-width: ${TABLET}px and min-width: ${MOBILE_LARGE}px)`,
    mobileLargeMediaQuery: `(max-width: ${MOBILE_LARGE-1}px and min-width: ${MOBILE}px)`,
    mobileMediaQuery: `(max-width: ${MOBILE-1}px and min-width: ${MOBILE_SMALL}px)`,
    mobileSmallMediaQuery: `(max-width: ${MOBILE_SMALL-1}px)`,
    allMobilesMediaQuery: `(max-width: ${MOBILE_LARGE-1}px)`,
    allTabletsMediaQuery: `(max-width: ${TABLET-1}px)`,
    mobileAveradgeAndSmallMediaQuery: `(max-width: ${MOBILE-1}px)`,

    mobileSmallSize: `${MOBILE_SMALL}px`,
    mobileSize: `${MOBILE}px`,
    mobileLargeSize: `${MOBILE_LARGE}px`,
    tabletSize: `${TABLET}px`,

    device,

    isDesktop: device === 'desktop',
    isTablet: device === 'tablet',
    isMobileLarge: device === 'mobileLarge',
    isMobile: device === 'mobile',
    isMobileSmall: device === 'mobileSmall',

    isDescktopAndSmaller: ['desktop', 'tablet', 'mobileLarge', 'mobile', 'mobileSmall'].includes(device),
    isTabletAndSmaller: ['tablet', 'mobileLarge', 'mobile', 'mobileSmall'].includes(device),
    isMobileLargeAndSmaller: ['mobileLarge', 'mobile', 'mobileSmall'].includes(device),
    isMobileAndSmaller: ['mobile', 'mobileSmall'].includes(device),
  });
};
